export default __webpack_public_path__ + "static/cinema-e634f7e646de709dd5d6f72b197c8a36.png";